import { ElLoading } from 'element-plus'

export const getFileByUrl = (attachment) => {
  fetch(attachment.fileUrl).then(res => res.blob()).then(blob => {
    return {
      name: item.fileName,
      uid: item.filePath,
      id: item.filePath,
      progress: 100,
      url: item.fileUrl,
      file: new File([blob], item.fileName, { type: blob.type }),
    }
  })
}

export const attachmentToFileList = (attachment, defineResponse) => {
  return (attachment || []).map(item => ({
    ...item,
    url: item.fileUrl,
    name: item.fileName,
    size: item.fileSize || 0,
    response: {
      name: item.fileName,
      path: item.filePath,
      downladUrl: item.fileUrl,
      previewUrl: item.previewPath,
      id: item.modelUploadId
    }
  }))
}

// post请求进行下载

/**
 * 通用POST请求下载文件
 * @param {string} url 请求地址
 * @param {object} data 请求体数据
 * @param {object} [headers={}] 请求头
 * @param {string} [filename] 指定下载文件名（可选）
 */
export const downloadFileByPost = async (url, data, headers = {}, filename) => {
  // 增加loading
  ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
  });
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: data,
    });

    if (!response.ok) {
      throw new Error('下载失败');
    }

    const blob = await response.blob();
    // 获取文件名
    let downloadName = filename;
    const contentDisposition = response.headers.get('content-disposition');
    if (!downloadName && contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match) {
        downloadName = decodeURIComponent(match[1]);
      }
    }
    if (!downloadName) {
      downloadName = 'downloaded_file';
    }

    // 创建下载链接并自动点击
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = downloadName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
    ElLoading.service().close()
  } catch (error) {
    console.error('文件下载出错:', error);
    ElLoading.service().close()
  }
};




// 处理json.parse的兼容方法
export const jsonParse = (str, errorValue = []) => {
  try {
    if (str === null || str === undefined || str === '') {
      return errorValue
    }

    let result = typeof str === 'string' ? JSON.parse(str) : str
    let depth = 0

    // 兼容模型把 JSON 结果再次字符串化，例如 "\"[{...}]\""
    while (typeof result === 'string' && depth < 2) {
      const trimmed = result.trim()
      if (!trimmed || !/^[\[{]/.test(trimmed)) {
        break
      }
      result = JSON.parse(trimmed)
      depth += 1
    }

    return result
  } catch (error) {
    return errorValue
  }
}

const unescapeJsonFragment = (str = '') => {
  return String(str)
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\r')
    .replace(/\\t/g, '\t')
    .replace(/\\"/g, '"')
    .replace(/\\\\/g, '\\')
}

const splitTopLevelJsonObjects = (inner = '') => {
  const chunks = []
  let depth = 0
  let start = -1

  for (let i = 0; i < inner.length; i += 1) {
    const ch = inner[i]
    if (ch === '{') {
      if (depth === 0) {
        start = i
      }
      depth += 1
    } else if (ch === '}') {
      depth -= 1
      if (depth === 0 && start !== -1) {
        chunks.push(inner.slice(start, i + 1))
        start = -1
      }
    }
  }

  return chunks
}

const extractJsonStringField = (chunk = '', field = '', isLastField = false) => {
  const marker = `"${field}"`
  const keyIdx = chunk.indexOf(marker)
  if (keyIdx === -1) {
    return ''
  }

  const colonIdx = chunk.indexOf(':', keyIdx + marker.length)
  if (colonIdx === -1) {
    return ''
  }

  let i = colonIdx + 1
  while (i < chunk.length && /\s/.test(chunk[i])) {
    i += 1
  }

  if (chunk[i] !== '"') {
    return ''
  }

  const valueStart = i + 1

  if (isLastField) {
    const braceIdx = chunk.lastIndexOf('}')
    if (braceIdx <= valueStart) {
      return ''
    }
    const body = chunk.slice(valueStart, braceIdx)
    const lastQuoteIdx = body.lastIndexOf('"')
    const rawValue = lastQuoteIdx === -1 ? body : body.slice(0, lastQuoteIdx)
    return unescapeJsonFragment(rawValue.trim())
  }

  let j = valueStart
  let rawValue = ''
  while (j < chunk.length) {
    const c = chunk[j]
    if (c === '\\' && j + 1 < chunk.length) {
      rawValue += c + chunk[j + 1]
      j += 2
      continue
    }
    if (c === '"') {
      break
    }
    rawValue += c
    j += 1
  }

  return unescapeJsonFragment(rawValue)
}

const salvageInventIdeaDocResult = (text = '') => {
  const inner = text.replace(/^\s*\[\s*/, '').replace(/\s*\]\s*$/, '')
  if (!inner.trim()) {
    return []
  }

  return splitTopLevelJsonObjects(inner)
    .map((chunk) => ({
      question: extractJsonStringField(chunk, 'question'),
      answer: extractJsonStringField(chunk, 'answer', true),
    }))
    .filter(item => item.question || item.answer)
}

/**
 * 解析发明构思 docResult（问答 JSON 数组字符串）
 * 兼容 answer 中含未转义双引号导致 JSON.parse 失败的情况
 */
export const parseInventIdeaDocResult = (raw) => {
  if (raw === null || raw === undefined || raw === '') {
    return []
  }

  if (Array.isArray(raw)) {
    return raw
  }

  const text = String(raw).trim()
  if (!text) {
    return []
  }

  const direct = jsonParse(text, null)
  if (Array.isArray(direct) && direct.length > 0) {
    return direct
  }

  const salvaged = salvageInventIdeaDocResult(text)
  if (salvaged.length > 0) {
    return salvaged
  }

  return Array.isArray(direct) ? direct : []
}

/**
 * 将数字转换为中文数字
 * @param {number} num 要转换的数字
 * @returns {string} 转换后的中文数字
 */
export const numberToChinese = (num) => {
  const chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
  
  if (num === 0) return chineseNumbers[0];
  if (num <= 10) return chineseNumbers[num];
  if (num < 20) return '十' + (num % 10 === 0 ? '' : chineseNumbers[num % 10]);
  if (num < 100) {
    const tens = Math.floor(num / 10);
    const ones = num % 10;
    return chineseNumbers[tens] + '十' + (ones === 0 ? '' : chineseNumbers[ones]);
  }
  
  // 对于更大的数字，可以继续扩展
  return num.toString();
}
